import { utils } from '@yola/ws-sdk';
import settingTypes from '../constants/setting-types';

const getSettingValueFromFieldValue = (setting, value) => {
  switch (setting) {
    case settingTypes.SITE_NAME:
    case settingTypes.BUSINESS_DESCRIPTION: {
      const trimmedValue = value.trim();
      return trimmedValue || null;
    }
    case settingTypes.BUSINESS_NAME: {
      const trimmedValue = value.trim();
      return utils.escapeHTML(trimmedValue);
    }
    case settingTypes.ADDRESSES:
    case settingTypes.BUSINESS_HOURS: {
      const trimmedValue = value.trim();
      return trimmedValue ? [utils.escapeHTML(trimmedValue)] : null;
    }
    case settingTypes.PHONES:
    case settingTypes.EMAILS: {
      const trimmedValue = value.trim();
      return trimmedValue ? [trimmedValue] : null;
    }
    case settingTypes.BUSINESS_CATEGORY: {
      return value ? value.value : null;
    }
    default: {
      return value;
    }
  }
};

export default getSettingValueFromFieldValue;
